import React from "react";
import {Chip, Stack, Tooltip, Typography} from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import {HourglassTop} from "@mui/icons-material";

import '../../css/App.css';
import {copyToClipboard} from "../../helpers/TextUtils";
import CopyIconButton from "./CopyIconButton";

const ZoomMeetingChip = ({ zoomMeetingUrl, chipStyle = {}, onCopy = copyToClipboard, showLabelInline = false }) => {
  const isMeetingUrlPresent = !!zoomMeetingUrl;
  
  const meetingId = zoomMeetingUrl 
    ? zoomMeetingUrl.slice(zoomMeetingUrl.lastIndexOf('/') + 1)
    : 'Link Pending';

  const meetingIcon = zoomMeetingUrl 
    ? <LaunchIcon style={{ fontSize: '0.9rem' }} /> 
    : <HourglassTop style={{ fontSize: '0.9rem' }} />;

  const meetingLabel = zoomMeetingUrl 
    ? meetingId 
    : 'Zoom room not created yet';

  const defaultChipStyle = {
    width: '1.2rem',
    height: '1.2rem',
    paddingLeft: '0.5rem',
    "&:hover": { backgroundColor: '#ffffffcc' },
    backgroundColor: '#ffffffcc',
    color: isMeetingUrlPresent ? 'blue' : '',
    textDecoration: isMeetingUrlPresent ? 'underline' : ''
  };

  const finalChipStyle = { ...defaultChipStyle, ...chipStyle };

  const content = (
    <Stack direction="row" alignItems="center">
      <CopyIconButton url={zoomMeetingUrl} onCopy={onCopy} ariaLabel="copy" />
      <Typography variant="subtitle2" color="white">
        {meetingLabel}
      </Typography>
    </Stack>
  );

  const chip = (
    <Chip
      icon={meetingIcon}
      component="a"
      size="small"
      href={zoomMeetingUrl}
      target="_blank"
      rel="noopener noreferrer"
      sx={finalChipStyle}
      clickable={isMeetingUrlPresent}
    />
  );

  if (showLabelInline) {
    return (
      <Stack direction="row" alignItems="center">
        <Typography
          variant="subtitle2"
          color="white"
          sx={{
            fontSize: '0.875rem',
            paddingRight: '0.5rem'
          }}
        >
          {meetingLabel}
        </Typography>
        <CopyIconButton url={zoomMeetingUrl} onCopy={onCopy} ariaLabel="copy" />
         {chip}
      </Stack>
    );
  }

  return (
    <Tooltip
      disableFocusListener
      arrow
      placement="bottom-start"
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": { backgroundColor: "black" },
          "& .MuiTooltip-arrow": { color: "black" }
        }
      }}
      title={content}
    >
      {chip}
    </Tooltip>
  );
};

export default ZoomMeetingChip;